
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea,
    Card,
    Modal,
    Button,
    Typography,
    ProTableOt,
    ExpandableText,
    DatePicker,
    setParamsFilter
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { ManageMARCRecordTable } from '../../Library/views/BackStage/ManageMARCRecord'
import { SerialsManagementForm } from "../../Library/views/BackStage/serials_management";
import { Trash2, Settings, } from "lucide-react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../ui/table";
import { useNavigate } from "react-router-dom";

const SerialOrderlistForm = ({
    formView = "edit", //edit onlyRead
    propsReloadCount,
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "cataloging.serial_orderlist_management",
}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {

        let subscription_orderlist_task_data = (values?.subscription_orderlist_task_data || [])
        let subscription_orderlist_task_data_first = subscription_orderlist_task_data.find((ele) => true)
        subscription_orderlist_task_data_first = setParamsFilter(subscription_orderlist_task_data_first)
        let subscription_orderlist_items_data = (values?.subscription_orderlist_items_data || []).map((value) => {
            return {
                ...value,
            }
        })
        onFormFinish({
            ...values,
            subscription_orderlist_items_data,
            subscription_orderlist_task_data: [{ ...subscription_orderlist_task_data_first }]

        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                propsForm={form}
                                propsReloadCount={propsReloadCount}
                                formView={formView}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    propsForm,
    field,
    keyPrefix = "cataloging.serial_orderlist_management",
    propsReloadCount,
    formView
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();
    const navigate = useNavigate()

    const columns = [
        {
            title: t('vendor'),
            dataIndex: "aqbookseller_name",
            key: "aqbookseller_name",
        },
        {
            title: t('bibTitle'),
            dataIndex: "title",
            key: "title",
            width: 300,
            render: (text, record, index) => {
                return (<ExpandableText maxLines={1} text={text} />)
            }
        },
        {
            title: t('received_serial_number'),
            dataIndex: "serialsadditems",
            key: "serialsadditems",
            render: (text, record, index) => {
                if (!!record?.serialsadditems) {
                    return (<>{t('create_new_item')}</>)
                }
                else {
                    return (<>{t('do_not_create_new_item')}</>)

                }
            }
        },
        {
            title: t('irregular_issue'),
            dataIndex: "skip_serialseq",
            key: "skip_serialseq",
            render: (text, record, index) => {
                if (!!record?.serialsadditems) {
                    return (<>{t('skip_issue_number')}</>)
                }
                else {
                    return (<>{t('keep_issue_number')}</>)

                }
            }
        },
        {
            title: t('manual_record_change'),
            dataIndex: "manualhistory",
            key: "manualhistory",
            render: (text, record, index) => {
                if (!!record?.manualhistory) {
                    return (<Row justify="center">
                        <Col>
                            <Typography.P>
                                {t('yes')}
                            </Typography.P>
                        </Col>
                    </Row>)
                }
                else {
                    return (<Row justify="center">
                        <Col>
                            <Typography.P>
                                {t('no')}
                            </Typography.P>
                        </Col>
                    </Row>)

                }
            }
        },
        {
            title: t('call_number'),
            dataIndex: "callnumber",
            key: "callnumber",
        },
        {
            title: t('library'),
            dataIndex: "branchname",
            key: "branchname",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {text} {record?.branchname}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        {
            title: t('public_note'),
            dataIndex: "notes",
            key: "notes",
        },
        {
            title: t('internal_note'),
            dataIndex: "internalnotes",
            key: "internalnotes",
        },
        {
            title: t('shelving_location'),
            dataIndex: "locationname",
            key: "locationname",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {text} {record?.locationname}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        {
            title: `${t('grace_period') + t('day')}`,
            dataIndex: "graceperiod",
            key: "graceperiod",
        },
        {
            title: t('first_issue_publication_date'),
            dataIndex: "firstacquidate",
            key: "firstacquidate",
        },
        {
            title: t('frequency'),
            dataIndex: "frequency_name",
            key: "frequency_name",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {record?.frequency_name}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        {
            title: t('subscription_length'),
            dataIndex: "subtype",
            key: "subtype",
            render: (text, record, index) => {
                return <Typography.P>{record?.sublength} {t(record?.subtype)}</Typography.P>
            }
        },
        {
            title: t('subscription_start_date'),
            dataIndex: "startdate",
            key: "startdate",
        },
        {
            title: t('subscription_end_date'),
            dataIndex: "enddate",
            key: "enddate",
        },
        {
            title: t('numbering_pattern'),
            dataIndex: "subscription_numberpatterns_label",
            key: "subscription_numberpatterns_label",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {record?.subscription_numberpatterns_label}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        // {
        //     title: t(`operation`),
        //     dataIndex: 'operation',
        //     key: 'operation',
        //     sorter: false,

        //     render: (text, record, index) => {
        //         return (<Button variant="ghost" size="icon"
        //             onClick={() => {
        //                 let oldData = propsForm.getFieldValue("subscription_orderlist_items_data")
        //                 let data = oldData.filter((ele, ind) => ind !== index)
        //                 propsForm.setFieldValue("subscription_orderlist_items_data", data)
        //                 // reload()
        //             }}
        //         >
        //             <Trash2 className="h-4 w-4" />
        //         </Button>)
        //     }
        // },

    ];
    const [count, setCount] = useState(0)
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const locController = useCRUDController({ apiRoute: "/koha/authorised_values" })
    const vendorController = useCRUDController({ apiRoute: "/koha/vendor" })
    const frequencyController = useCRUDController({ apiRoute: "/koha/serial/periodicity" });
    const numberingpatternController = useCRUDController({ apiRoute: "/koha/serial/numberingpattern" })
    useEffect(() => {
        libraryController.getData({})
        locController.getData({ category: "LOC" })
        vendorController.getData({})
        numberingpatternController.getData({})
        frequencyController.getData({})

    }, []);
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Card title={t('order_information')} >
                        <Form.List
                            {...field}
                            fieldKey={[field?.fieldKey ?? '', 'subscription_orderlist_task_data']}
                            name={[field?.name ?? '', 'subscription_orderlist_task_data']}
                        >
                            {(fields, { add, remove }) => <Row gutter={[8, 8]}>
                                {fields.map((field, index) => {
                                    return (
                                        <Col span={24}>
                                            <Row>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                                    <Form.Item
                                                        {...field}
                                                        name={[field?.name ?? '', 'subscription_orderlist_serial']}
                                                        fieldKey={[field?.fieldKey ?? '', 'subscription_orderlist_serial']}
                                                        label={t('order_number')}
                                                        labelCol={24}
                                                        wrapperCol={24}
                                                    >
                                                        <Input disabled placeholder={t('auto_fill_on_completion')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                                    <Form.Item
                                                        {...field}
                                                        name={[field?.name ?? '', 'create_user_name']}
                                                        fieldKey={[field?.fieldKey ?? '', 'create_user_name']}
                                                        label={t('creator')}
                                                        labelCol={24}
                                                        wrapperCol={24}
                                                    >
                                                        <Input disabled placeholder={t('auto_fill_on_completion')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                                    <Form.Item
                                                        {...field}
                                                        name={[field?.name ?? '', 'create_time']}
                                                        fieldKey={[field?.fieldKey ?? '', 'create_time']}
                                                        label={t('creation_time')}
                                                        labelCol={24}
                                                        wrapperCol={24}
                                                    >
                                                        <Input type="date" disabled placeholder={t('auto_fill_on_completion')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                                    <Form.Item
                                                        {...field}
                                                        name={[field?.name ?? '', 'subscriptionid_count']}
                                                        fieldKey={[field?.fieldKey ?? '', 'subscriptionid_count']}
                                                        label={t('journal_item_quantity')}
                                                        labelCol={24}
                                                        wrapperCol={24}
                                                    >
                                                        <Input disabled placeholder={t('auto_fill_on_completion')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                                    <Form.Item
                                                        {...field}
                                                        name={[field?.name ?? '', 'task_name']}
                                                        fieldKey={[field?.fieldKey ?? '', 'task_name']}
                                                        label={t('name')}
                                                        labelCol={24}
                                                        wrapperCol={24}
                                                        rules={[{ required: true, message: t('please_input_item') }]}
                                                    >
                                                        <Input disabled={formView === "onlyRead"} placeholder={t('please_input_item')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                                    <Row align={"bottom"}>
                                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                            <Form.Item
                                                                {...field}
                                                                name={[field?.name ?? '', 'start_time']}
                                                                fieldKey={[field?.fieldKey ?? '', 'start_time']}
                                                                label={t('order_time_period')}
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                rules={[{ required: true, message: t('please_input_item') }]}

                                                            >
                                                                <Input disabled={formView === "onlyRead"} type={'date'} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                            <Form.Item
                                                                {...field}
                                                                name={[field?.name ?? '', 'end_time']}
                                                                fieldKey={[field?.fieldKey ?? '', 'end_time']}
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                rules={[{ required: true, message: t('please_input_item') }]}

                                                            >
                                                                <Input disabled={formView === "onlyRead"} type={'date'} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    )
                                })}

                            </Row>}
                        </Form.List>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card title={t('journal_list')} >
                        <Row>
                            <Col span={24}>
                                <Form.List
                                    {...field}
                                    fieldKey={[field?.fieldKey ?? '', 'subscription_orderlist_items_data']}
                                    name={[field?.name ?? '', 'subscription_orderlist_items_data']}
                                >
                                    {(fields, { add, remove }) => <Row gutter={[8, 8]}>
                                        <Col span={24}>
                                            <Row justify="end">
                                                {formView === "edit" &&
                                                    <Col>
                                                        <SerialsManagementModal
                                                            key={"newModal"}
                                                            mode="new"
                                                            onFormFinish={(value) => {

                                                                let frequency_name = frequencyController?.ResponseData.find((val) => {
                                                                    return val?.id === value?.frequency
                                                                })?.description
                                                                let aqbookseller_name = vendorController?.ResponseData.find((val) => {
                                                                    return val?.id === value?.aqbooksellerid
                                                                })?.name
                                                                let branchname = libraryController?.ResponseData.find((val) => {
                                                                    return val?.branchcode === value?.branchcode
                                                                })?.branchname
                                                                let locationname = locController?.ResponseData.find((val) => {
                                                                    return val?.authorised_value === value?.location
                                                                })?.description_opac
                                                                let numberingmethod = numberingpatternController?.ResponseData.find((val) => {
                                                                    return val?.id === value?.numbering_pattern
                                                                })?.label
                                                                add({
                                                                    ...value,
                                                                    frequency_name,
                                                                    aqbookseller_name,
                                                                    branchname,
                                                                    locationname,
                                                                    numberingmethod
                                                                })
                                                            }}
                                                            frequencyOptions={frequencyController?.ResponseData}
                                                            venderOptions={vendorController?.ResponseData}
                                                            libraryOptions={libraryController?.ResponseData}
                                                            locOptions={locController?.ResponseData}
                                                            numberingpatternOptions={numberingpatternController?.ResponseData}
                                                        />
                                                    </Col>}
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <div className="overflow-x-auto">
                                                <Table>
                                                    <TableHeader
                                                        style={{
                                                            fontSize: "16px",

                                                        }}
                                                    >
                                                        <TableRow>
                                                            {columns?.map((columnValue) => {
                                                                return (<TableHead  >{columnValue?.title}</TableHead>)
                                                            })}
                                                            <TableHead >{t('operation')}</TableHead>
                                                        </TableRow>
                                                    </TableHeader>
                                                    <TableBody
                                                        style={{
                                                            fontSize: "16px",

                                                        }}>
                                                        {fields?.map((subscriptionField, subscriptionIndex) => {
                                                            let record = propsForm.getFieldValue('subscription_orderlist_items_data', count)?.[subscriptionIndex]
                                                            let subscription_orderlist_id = propsForm.getFieldValue('subscription_orderlist_id', count) 
                                                            return (<TableRow key={subscriptionField?.id}>
                                                                {columns?.map((columnValue) => {
                                                                    if (columnValue?.key === "serialsadditems") {
                                                                        if (!!record?.serialsadditems) {
                                                                            return (<TableCell>{t('create_new_item')}</TableCell>)
                                                                        }
                                                                        else {
                                                                            return (<TableCell>{t('do_not_create_new_item')}</TableCell>)
                                                                        }
                                                                    }
                                                                    else if (columnValue?.key === "manualhistory") {
                                                                        if (!!record?.manualhistory) {
                                                                            return (<TableCell>{t('yes')}</TableCell>)
                                                                        }
                                                                        else {
                                                                            return (<TableCell>{t('no')}</TableCell>)
                                                                        }
                                                                    }
                                                                    else if (columnValue?.key === "skip_serialseq") {
                                                                        if (!!record?.irregular_issue) {
                                                                            return (<TableCell>{t('skip_issue_number')}</TableCell>)
                                                                        }
                                                                        else {
                                                                            return (<TableCell>{t('keep_issue_number')}</TableCell>)
                                                                        }
                                                                    }
                                                                    else if (columnValue?.key === "skip_serialseq") {
                                                                        if (!!record?.irregular_issue) {
                                                                            return (<TableCell>{t('skip_issue_number')}</TableCell>)
                                                                        }
                                                                        else {
                                                                            return (<TableCell>{t('keep_issue_number')}</TableCell>)
                                                                        }
                                                                    }
                                                                    else if (columnValue?.key === "subtype") {
                                                                        let temp = [{
                                                                            label: "期",
                                                                            value: "issues"
                                                                        },
                                                                        {
                                                                            label: "週",
                                                                            value: "weeks"
                                                                        },
                                                                        {
                                                                            label: "月",
                                                                            value: "months"
                                                                        },]
                                                                        let subtypename = temp?.find((ele) => ele?.value === record?.subtype)?.label || "-"
                                                                        return (<TableCell ><Typography.P>  {(record?.sublength!=="0" || !record?.sublength) ? `${record?.sublength}${subtypename}` :""} </Typography.P></TableCell>)
                                                                    }
                                                                    else {
                                                                        return (<TableCell >{record?.[columnValue?.dataIndex]}</TableCell>)
                                                                    }
                                                                })}
                                                                {formView === "edit" ?
                                                                    <TableCell className="text-right">
                                                                        <SerialsManagementModal
                                                                            frequencyOptions={frequencyController?.ResponseData}
                                                                            venderOptions={vendorController?.ResponseData}
                                                                            libraryOptions={libraryController?.ResponseData}
                                                                            locOptions={locController?.ResponseData}
                                                                            numberingpatternOptions={numberingpatternController?.ResponseData}
                                                                            field={subscriptionField}
                                                                            // propsForm={propsForm}
                                                                            propsDefaultValue={propsForm.getFieldValue('subscription_orderlist_items_data', count)?.[subscriptionIndex]}
                                                                            onFormFinish={(value) => {
                                                                                let frequency_name = frequencyController?.ResponseData.find((val) => {
                                                                                    return val?.id === value?.frequency
                                                                                })?.description
                                                                                let aqbookseller_name = vendorController?.ResponseData.find((val) => {
                                                                                    return val?.id === value?.aqbooksellerid
                                                                                })?.name
                                                                                let branchname = libraryController?.ResponseData.find((val) => {
                                                                                    return val?.branchcode === value?.branchcode
                                                                                })?.branchname
                                                                                let locationname = locController?.ResponseData.find((val) => {
                                                                                    return val?.authorised_value === value?.location
                                                                                })?.description_opac
                                                                                let numberingmethod = numberingpatternController?.ResponseData.find((val) => {
                                                                                    return val?.id === value?.numbering_pattern
                                                                                })?.label
                                                                                let newValue = propsForm.getFieldValue('subscription_orderlist_items_data', count).map((val, inx) => {
                                                                                    if (inx === subscriptionIndex) {
                                                                                        return {
                                                                                            ...value,
                                                                                            frequency_name,
                                                                                            aqbookseller_name,
                                                                                            branchname,
                                                                                            locationname,
                                                                                            numberingmethod
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        return {
                                                                                            ...val
                                                                                        }
                                                                                    }
                                                                                })
                                                                                propsForm.setFieldValue("subscription_orderlist_items_data", newValue)
                                                                            }}
                                                                        />
                                                                        <Button variant="ghost" size="icon"
                                                                            onClick={() => remove(subscriptionIndex)}
                                                                        >
                                                                            <Trash2 className="h-4 w-4" />
                                                                        </Button>
                                                                    </TableCell>
                                                                    :
                                                                    <TableCell>
                                                                        <Button onClick={() => {
                                                                            navigate(`../serial_receive?biblionumber=${record?.biblionumber|| ""}&branchcode=${record?.branchcode|| ""}&subscription_orderlist_id=${subscription_orderlist_id || ""}`)
                                                                        }}>前往點收</Button>
                                                                    </TableCell>
                                                                }
                                                            </TableRow>)
                                                        })}
                                                        {fields.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={columns.length + 1} className="text-center py-4">
                                                                    尚未新增期刊
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>}
                                </Form.List>
                            </Col>
                        </Row>
                    </Card>
                </Col>

            </Row>
        </>
    );
};
const SerialsManagementModal = ({
    propsDefaultValue,
    field,
    propsForm,
    propsOpen = null,
    propsLoading = null,
    openButtonText = "詳細資訊",
    mode = "",
    propsSetOpen = () => { },
    propsHandleOk = () => { },
    onFormFinish = () => { },
    keyPrefix = "cataloging.serial_orderlist_management",
    venderOptions,
    libraryOptions,
    locOptions,
    frequencyOptions,
    numberingpatternOptions
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const { t } = useTranslation('translation', { keyPrefix })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null)
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);

            if (mode === "new") {
                form.reset()
            }
            else {
                form.setFieldsValue({ ...propsDefaultValue })
            }
        } else {
            propsSetOpen(true);
            if (mode === "new") {
                form.reset()
            }
            else {
                form.setFieldsValue({ ...propsDefaultValue })
            }
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        setLoading(false);

    };

    const handleOk = (value) => {
        setLoading(true);
        propsHandleOk(selectRow)
        closeModal();
        onFormFinish(value)
    };

    const handleCancel = () => {
        closeModal();
    };


    return (
        <div>

            {mode === "new" ?
                <Button onClick={showModal} >
                    新增期刊
                </Button> : <Button variant="ghost" size="icon"
                    onClick={showModal}
                >
                    <Settings className="h-4 w-4" />
                </Button>}
            <Modal
                title={`${openButtonText}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={() => {
                    form.submit()
                }}
                onCancel={handleCancel}
                confirmLoading={loading}
                maskClosable={false}
                width={1800}
                contentStyle={{
                    padding: 16,
                }}
                okText={'確認'}
                cancelText={'取消'}
            >
                <Row>
                    <Col span={24}>
                        <SerialsManagementForm
                            // key={field?.id}
                            // field={field}
                            propsForm={form}
                            onFormFinish={(value) => {
                                handleOk(value)
                            }}
                            venderOptions={venderOptions}
                            libraryOptions={libraryOptions}
                            locOptions={locOptions}
                            locMenuPortalTarget={null}
                            frequencyOptions={frequencyOptions}
                            numberingpatternOptions={numberingpatternOptions}
                        />
                    </Col>
                </Row>
            </Modal>

        </div>
    );
}




export default SerialOrderlistForm;
